import { Pipe, PipeTransform } from '@angular/core';
import * as QRCode from 'qrcode';

/**
 * Pipe to generate a QR code from a string.
 * Examples:
 *  - {{ 'https://www.example.com' | qrCode | async }}
 *  - {{ 'https://www.example.com' | qrCode:128 | async }} -> With a custom width
 */
@Pipe({
    name: 'qrCode',
    standalone: true,
})
export class QrCodePipe implements PipeTransform {
    public transform(text: string, width?: number): Promise<string> {
        return QRCode.toDataURL(text, { margin: 1, width });
    }
}
